import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { ServicePayload, WorkspaceMemberDto } from '@nx-frontend/shared/types';

interface GetWorkspaceMembersPayload extends ServicePayload {
  workspaceId: string;
}

export const getWorkspaceMembers = async ({
  host,
  userId,
  workspaceId,
}: GetWorkspaceMembersPayload): Promise<WorkspaceMemberDto[]> => {
  const response = await axiosClient.get(`${assertServiceHost(host)}/v1/workspaces/${workspaceId}/members`, { userId });
  return response.data;
};
